function createProductCardSrcset(imageUrl, widths = [200, 300, 400]) {
  if (!imageUrl) return "";

  const url = new URL(imageUrl, window.location.origin);

  return widths.map((width) => {
    url.searchParams.set("width", width);
    return `${url.href} ${width}w`;
  }).join(", ");
}

function setResponsiveProductCardImage(image, source, alt) {
  if (!image || !source) return;

  image.src = source;
  image.srcset = createProductCardSrcset(source);
  if (alt !== undefined) image.alt = alt;
}

function updateProductCardFromSwatch(colorSwatch, productItem, options = {}) {
  const primaryImage = productItem.querySelector(".product-item__primary-image");
  const imageWrapper = productItem.querySelector(".product-item__image-wrapper");
  const cardLink = productItem.querySelector(".product-item__aspect-ratio");
  const radio = colorSwatch.querySelector(".color-swatch__radio");
  const variantId = radio?.dataset.variantId;
  const primaryImageUrl = colorSwatch.dataset.img;
  const hoverImageUrl = colorSwatch.dataset.hoverImage;
  const primaryAlt = colorSwatch.dataset.alt || "";
  const hoverAlt = colorSwatch.dataset.hoverImageAlt || primaryAlt;

  if (radio) radio.checked = true;

  setResponsiveProductCardImage(primaryImage, primaryImageUrl, primaryAlt);
  if (primaryImage) primaryImage.dataset.currentColor = radio?.value?.toLowerCase() || "";

  if (imageWrapper) {
    if (hoverImageUrl && hoverImageUrl !== primaryImageUrl) {
      imageWrapper.dataset.hoverImage = hoverImageUrl;
      imageWrapper.dataset.hoverImageAlt = hoverAlt;
    } else {
      delete imageWrapper.dataset.hoverImage;
      delete imageWrapper.dataset.hoverImageAlt;
      imageWrapper.querySelector(".product-item__secondary-image")?.remove();
      imageWrapper.classList.remove("product-item__image-wrapper--multiple");
    }
  }

  const secondaryImage = imageWrapper?.querySelector(".product-item__secondary-image");
  if (secondaryImage && imageWrapper?.dataset.hoverImage) {
    setResponsiveProductCardImage(
      secondaryImage,
      imageWrapper.dataset.hoverImage,
      imageWrapper.dataset.hoverImageAlt || ""
    );
  } else if (imageWrapper?.matches(":hover") && cardLink) {
    createProductCardHoverImage(imageWrapper, cardLink);
  }

  if (!variantId || options.updateNavigation === false) return;

  const productUrl = productItem.dataset.productUrl;
  productItem.querySelectorAll('a[href*="/products"]').forEach((link) => {
    const destination = new URL(productUrl || link.href, window.location.origin);
    destination.searchParams.set("variant", variantId);
    link.href = destination.toString();
  });

}

function createProductCardHoverImage(imageWrapper, cardLink) {
  const source = imageWrapper.dataset.hoverImage;
  if (!source || cardLink.querySelector(".product-item__secondary-image")) return;

  const image = document.createElement("img");
  image.className = "product-item__secondary-image";
  image.loading = "lazy";
  image.decoding = "async";
  image.fetchPriority = "low";
  const primaryImage = cardLink.querySelector(".product-item__primary-image");
  image.sizes = primaryImage?.sizes || "";
  setResponsiveProductCardImage(image, source, imageWrapper.dataset.hoverImageAlt || primaryImage?.alt || "");
  cardLink.append(image);
  imageWrapper.classList.add("product-item__image-wrapper--multiple");
}

function prepareProductCardHoverImage(productItem) {
  const imageWrapper = productItem.querySelector(".product-item__image-wrapper");
  if (!imageWrapper) return;

  const swatches = Array.from(productItem.querySelectorAll(".product-item-meta__swatch-list .color-swatch"));
  const currentColor = productItem.querySelector(".product-item__primary-image")?.dataset.currentColor?.toLowerCase();
  const currentSwatch = swatches.find((swatch) => swatch.querySelector(".color-swatch__radio")?.value?.toLowerCase() === currentColor)
    || swatches.find((swatch) => swatch.querySelector(".color-swatch__radio")?.checked)
    || swatches[0];

  // A color card must always use the selected color's second image. The
  // server-provided default is only for cards with no color swatches.
  if (currentSwatch) {
    updateProductCardFromSwatch(currentSwatch, productItem, { updateNavigation: false });
  } else if (imageWrapper.dataset.defaultHoverImage) {
    imageWrapper.dataset.hoverImage = imageWrapper.dataset.defaultHoverImage;
    imageWrapper.dataset.hoverImageAlt = imageWrapper.dataset.defaultHoverImageAlt || "";
  }
}

function initializeProductCardInteractions() {
  if (document.documentElement.dataset.productCardInteractionsBound === "true") return;
  document.documentElement.dataset.productCardInteractionsBound = "true";

  const desktopHover = window.matchMedia("(hover: hover) and (pointer: fine)");

  document.addEventListener("change", (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(".product-item-meta__swatch-list .color-swatch__radio")) return;

    const colorSwatch = input.closest(".color-swatch");
    const productItem = input.closest(".product-item");
    if (colorSwatch && productItem) updateProductCardFromSwatch(colorSwatch, productItem);
  });

  document.addEventListener("pointerover", (event) => {
    if (!desktopHover.matches) return;

    const imageWrapper = event.target.closest(".product-item__image-wrapper");
    if (!imageWrapper || imageWrapper.contains(event.relatedTarget)) return;

    const productItem = imageWrapper.closest(".product-item");
    const cardLink = imageWrapper.querySelector(".product-item__aspect-ratio");
    if (!productItem || !cardLink) return;

    prepareProductCardHoverImage(productItem);
    createProductCardHoverImage(imageWrapper, cardLink);
  });
}

function initializeGlobalProductCards() {
  initializeProductCardInteractions();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeGlobalProductCards);
} else {
  initializeGlobalProductCards();
}
